import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { MarkdownComponent } from 'ngx-markdown';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedModule } from '@shared/shared.module';
import { DOCK_RENDER_ZONE } from '@shared/floating-panel/dock-render-zone.token';
import { HdCircuitInfoService } from '../hd-circuit-info.service';
import { HdCircuitsOverviewInfoContext } from './hd-circuit-info-context.model';
import {
  HD_CIRCUIT_INFO_DEFAULT_VARIANT,
  HdCircuitInfoVariant,
} from './hd-circuit-info-variant';
import { HdCircuitInfoKernwoordenComponent } from './shared/hd-circuit-info-kernwoorden.component';

/**
 * Algemeen overzichts-info-paneel: rendert de README_extended-equivalent
 * (algemene introductie op circuits, circuitgroepen, stromen, format-kanalen).
 *
 * Geen circuit-key — toont één algemeen markdown-document. De variant-input
 * is voorbereid voor latere ondersteuning van compact/normal/extended bronnen
 * maar laadt momenteel altijd hetzelfde overzichts-bestand.
 */
@Component({
  selector: 'hd-circuits-overview-info',
  templateUrl: './hd-circuits-overview-info.component.html',
  styleUrl: './hd-circuits-overview-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MarkdownComponent, SharedModule, TranslocoModule, HdCircuitInfoKernwoordenComponent],
})
export class HdCircuitsOverviewInfoComponent {
  private readonly circuitInfoService = inject(HdCircuitInfoService);
  private readonly dockRenderZone = inject(DOCK_RENDER_ZONE, { optional: true });
  protected readonly isFloating = this.dockRenderZone == null;

  readonly context = input<HdCircuitsOverviewInfoContext>({});

  protected readonly variant = signal<HdCircuitInfoVariant>(HD_CIRCUIT_INFO_DEFAULT_VARIANT);

  protected readonly overview = computed(() => this.circuitInfoService.overviewTranslation());
  protected readonly ui = computed(() => this.circuitInfoService.uiLabels());
  protected readonly markdownSrc = computed(() =>
    this.circuitInfoService.overviewMarkdownUrl(this.variant()),
  );
}
